import React, { useEffect } from "react";
import "./style.scss";
import LeaderboardTable from "../../components/Leaderboard/LeaderboardTable";

function Leaderboard() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="leaderboard">
      <div className="leaderboard-header">
        <p>
          We rank our users based on their profit percentage. This data updates
          at varying times.
        </p>
      </div>

      <LeaderboardTable />
    </div>
  );
}

export default Leaderboard;
